import { MP_VALUE_TYPE } from './enum.mp-value';
import mixpanel from 'mixpanel-browser';
import { getSource, getUserStatus } from '@/utils/cookie';

const primaryToken = process.env.VUE_APP_MIXPANEL_PRIMARY_TOKEN_PROD;
const secondaryToken = process.env.VUE_APP_MIXPANEL_SECONDARY_TOKEN_PROD;

import isAdmin from '../is-admin';
import MpProperty from './enum.mp-property';
import { UserRole, UserStatus } from '@/resource/user/user.model';

mixpanel.init(primaryToken);
mixpanel.init(secondaryToken, {}, 'secondaryMixpanel');

const primaryMixpanel = mixpanel;
const secondaryMixpanel = mixpanel.secondaryMixpanel;

export interface SendMPEventParams {
  event: MP_VALUE_TYPE;
  properties?: MpProperty;
  mixpanelSecond?: boolean;
}

export const sendMpEvent = async (sendMPEventParams: SendMPEventParams) => {
  if (isAdmin()) {
    return;
  }
  const { event, properties, mixpanelSecond } = sendMPEventParams;

  try {
    const adSource = getSource() || null;

    const allProperties = {
      ...properties,
      marketing: adSource,
    };
    if (!mixpanelSecond) {
      primaryMixpanel.track(event, allProperties);
    } else {
      secondaryMixpanel.track(event, allProperties);
    }
  } catch (error) {
    console.log(error);
  }
};

export const identifyUser = async (
  email: string,
  firstName: string | undefined,
  lastName: string | undefined,
  phone: string | undefined,
  userStatus: UserStatus | undefined,
  role: UserRole | undefined,
) => {
  if (isAdmin()) {
    return;
  }

  try {
    primaryMixpanel.identify(email);
    primaryMixpanel.people.set({
      'Plan Type': getUserStatus(),
      $name: firstName,
      $firstName: firstName,
      $lastName: lastName,
      $email: email,
      $telefon: phone,
      $status: userStatus,
      $role: role,
    });

    secondaryMixpanel.identify(email);
    secondaryMixpanel.people.set({
      'Plan Type': getUserStatus(),
      $name: firstName,
      $firstName: firstName,
      $lastName: lastName,
      $email: email,
      $telefon: phone,
      $status: userStatus,
      $role: role,
    });
  } catch (error) {
    console.log(error);
  }
};

export const timeMpEvent = async (event: MP_VALUE_TYPE) => {
  if (isAdmin()) {
    return;
  }

  try {
    primaryMixpanel.time_event(event);
  } catch (error) {
    console.log(error);
  }
};
